export default __webpack_public_path__ + "static/media/457.dea6eedc.png";